module.exports = __webpack_public_path__ + "static/stephanie-c7c835626f8878e1971737f46c35aeb6.png";